"use client";

import { useVenueDetail } from "@/hooks/venueContext";
import React from "react";
import { useEffect } from "react";

interface Props {
  data: Venue.List;
}

export default function SetVenueDetail({ data }: Props) {
  const { setVenue } = useVenueDetail();

  useEffect(() => {
    setVenue(data as Venue.List);
  }, [data]);

  useEffect(() => {
    if (window) window.scrollTo(0, 0);
  }, []);

  return <></>;
}
